export default {"src":"/_next/static/media/intro-step-icon-2.bcfe55ea.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};